import { useState } from "react";
import { Link } from "react-router-dom";

function ChallengeFilters({ status, setStatus }) {
    return (
        <Link to={`/challenges`}>
            <div className="flex-c">
                <div id="custom-tab-filters">

                    <div
                        className={status == "active" ? "selected g-orange" : ""}
                        onClick={() => setStatus("active")}
                    >
                        <h6>ACTIVE</h6>
                    </div>
                    <div
                        className={status == "completed" ? "selected g-orange" : ""}
                        onClick={() => setStatus("completed")}
                    >
                        <h6>HISTORY</h6>
                    </div>
                    <div
                        className={status == "upcoming" ? "selected g-orange" : ""}
                        onClick={() => setStatus("upcoming")}
                    >
                        <h6>UPCOMING</h6>
                    </div>
                </div>
            </div>
        </Link>
    );
}

export default ChallengeFilters;